import { Link } from 'react-router-dom';
import coolCharacter from '../assets/svg-files/not-found-page-character.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const NotFound = () => {
  return (
    <>
      <div className="relative w-full min-h-screen overflow-hidden bg-white">
 
        <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 min-h-screen flex items-center justify-center">
          <div className="max-w-5xl w-full flex flex-col items-center text-center py-12">
            <div className="mb-8 sm:mb-10 relative">
              <img 
                src={coolCharacter} 
                alt="Pocman character looking confused" 
                className="w-64 h-64 sm:w-80 sm:h-80 lg:w-[420px] lg:h-[420px] drop-shadow-2xl relative z-10"
              />
            </div>
            <div className="mb-6 relative">
              <h1 className="font-nunito font-bold text-4xl sm:text-[10rem] lg:text-[14rem] tracking-tighter text-[#C025D3] leading-none">
                404
              </h1>
            </div>

            <h2 className="font-nunito font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-gray-900 mb-3 px-4">
              Oops!
            </h2>

            <p className="font-nunito font-bold text-lg sm:text-xl lg:text-2xl text-gray-400 max-w-2xl mb-10 px-4 leading-relaxed">
              This page took a wrong turn. Let's get you back!
            </p>

            <div className="relative inline-block">

              <Link to="/">
                <button
                  type="button"
                  className="relative font-nunito bg-[#C025D3] hover:bg-[#7BF2BC] text-white font-black text-lg px-10 py-5 rounded-2xl"
                >
                  <span className="flex items-center gap-3">
                    <FontAwesomeIcon icon={faArrowLeft} className="text-2xl" />
                    <span>Back to Home</span>
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
